import api from './api';

export type MaterialResource = {
  id: string;
  title: string;
  description?: string | null;
  fileName?: string | null;
  url?: string | null;
  updatedAt?: string | null;
};

export type VideoResource = {
  id: string;
  title: string;
  description?: string | null;
  embedHtml?: string | null;
  url?: string | null;
  thumbnailUrl?: string | null;
  updatedAt?: string | null;
};

function normalizeResourceId(prefix: string, value: unknown, index: number) {
  if (value === null || value === undefined) {
    return `${prefix}-${index}`;
  }
  return String(value);
}

export async function listMaterialsByCategory(categorySlug: string) {
  const { data } = await api.get('materials', { params: { category: categorySlug } });
  const rawList = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];

  return rawList.map((item: any, index: number): MaterialResource => ({
    id: normalizeResourceId('material', item?.id ?? item?.uuid ?? item?.slug, index),
    title: item?.title ?? item?.name ?? 'Material sem título',
    description: item?.description ?? item?.resume ?? item?.summary ?? null,
    fileName: item?.file_name ?? item?.fileName ?? item?.filename ?? null,
    url: item?.url ?? item?.link ?? item?.file_url ?? item?.download_url ?? null,
    updatedAt: item?.updated_at ?? item?.updatedAt ?? null,
  }));
}

export async function listVideosByCategory(categorySlug: string) {
  const { data } = await api.get('videos', { params: { category: categorySlug } });
  const rawList = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];

  return rawList.map((item: any, index: number): VideoResource => ({
    id: normalizeResourceId('video', item?.id ?? item?.uuid ?? item?.slug, index),
    title: item?.title ?? item?.name ?? 'Vídeo sem título',
    description: item?.description ?? item?.resume ?? item?.summary ?? null,
    embedHtml: item?.embed ?? item?.embed_html ?? item?.video_embed ?? null,
    url: item?.url ?? item?.link ?? item?.video_url ?? null,
    thumbnailUrl: item?.thumbnail ?? item?.thumbnail_url ?? null,
    updatedAt: item?.updated_at ?? item?.updatedAt ?? null,
  }));
}
